import RestRepository from "@candybox/repository/rest";
import partnerMap from "@app/partner/requests/partner-repository";
import { singleton } from "@candybox/helpers";
import Partner  from "@app/partner/documents/partner";

export default singleton( () => {
    return new RestRepository(Partner, partnerMap());
});
